import React from 'react';
import { Wrapper, FooterLink, FooterButton, LinksContainer } from './footerContent.style';
import { t } from '../../i18n';
import {
  getApiHost,
  isOneTrustEnabled,
  openCookieSettings,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL,
} from '../../settings/index';

interface IOwnProps {
  theme?: {
    assets?: {
      footerLogo?: string;
    };
  };
  isApiDocsAvailable: boolean;
}

const FooterContent: React.FC<IOwnProps> = ({ isApiDocsAvailable }) => {
  const apiDocsUrl = `${getApiHost()}/api-docs/index.html`;

  return (
    <Wrapper>
      <LinksContainer>
        <div className="link-container">
          <FooterLink target="_blank" to="/user-guide" data-cy="footer_link-user_guide">
            {t('dash.footerContent.user_guides_link')}
          </FooterLink>
        </div>

        {isApiDocsAvailable && (
          <div className="link-container">
            <FooterLink target="_blank" to={{ pathname: apiDocsUrl }} data-cy="footer_link-api_docs">
              {t('dash.footerContent.api_docs_link')}
            </FooterLink>
          </div>
        )}

        <div className="link-container">
          <FooterLink target="_blank" to={{ pathname: PRIVACY_POLICY_URL }} data-cy="footer_link-privacy_policy">
            {t('dash.footerContent.privacy_policy_link')}
          </FooterLink>
        </div>

        <div className="link-container">
          <FooterLink target="_blank" to={{ pathname: COOKIE_POLICY_URL }} data-cy="footer_link-cookie_policy">
            {t('dash.footerContent.cookie_policy_link')}
          </FooterLink>
        </div>

        {isOneTrustEnabled && (
          <div className="link-container">
            <FooterButton type="button" onClick={openCookieSettings} data-cy="footer_link-cookie_settings">
              {t('dash.footerContent.cookie_settings_link')}
            </FooterButton>
          </div>
        )}
      </LinksContainer>
    </Wrapper>
  );
};

export default FooterContent;
